import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import LogoData from '../app-logo/logo-data'
import { Setting } from '../app-icon/Icons'
import MGrid from './MGrid'
import MTable from './MTable'
import { ButtonContained } from '../app-button/button'
import { format } from 'date-fns'
import ruLocale from 'date-fns/locale/ru'
import MDateRangePicker from './MDateRangePicker'
import MChart from './MChart'
import { withSnackbar } from 'notistack'
import cx from 'classnames'
import BannerReportAnalitycsBrick from './BannerReportAnalitycsBrick'
import PopupSettings from './PopupSettings'

const styles = theme => ({
  reportDialog: {
    backgroundColor: '#f8f8f8',
  },
  reportDialogWrapper: {
    backgroundColor: '#f8f8f8',
    width: '100%',
    height: '100%',
    paddingTop: 69,
  },
  reportDialogAppBar: {
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  },
  logoRow: {
    '& a': {
      width: 80,
      height: 'auto',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& div': {
      width: 50,
      '&:first-child': {
        height: 44,
      },
      '&:last-child': {
        height: 30,
      },
    },
  },
  appBarActions: {
    display: 'flex',
    alignItems: 'center',
  },
  appBarTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  mSettingBtn: {
    border: 0,
    outline: 'none',
    background: 'transparent',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  toggleCalendar: {
    position: 'relative',
    height: 40,
    fontSize: 16,
    width: 300,
    padding: '0 40px 0 20px',
    whiteSpace: 'nowrap',
    lineHeight: 2.5,
    color: '#ffffff',
    marginRight: 25,
    '&:after': {
      content: "''",
      position: 'absolute',
      top: '50%',
      marginTop: -4,
      right: 16,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 4px 0 4px',
      borderColor: '#ffffff transparent transparent transparent',
    },
  },
  chartWraper: {
    maxWidth: 990,
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
  },
  chartBox: {
    width: 490,
    height: 202,
  },
  dateRangeWrapper: {
    width: 462,
    position: 'absolute',
    top: 75,
    right: 24,
    background: '#fff',
    boxShadow: '0px 12px 12px rgba(0,0,0,0.3)',
    borderRadius: 8,
    overflow: 'hidden',
  },
  backDropDateRange: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
  },
  overlayUpdate: {
    width: '100%',
    height: '100vh',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
    overflow: 'hidden',
  },
  ripple: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    position: 'absolute',
    top: 'calc(50% - 30px)',
    left: 'calc(50% - 30px)',
    animationName: 'ripple',
    animationDuration: '1s',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'alternate-reverse',
    animationIterationCount: 'infinite',
    transform: 'scale(0)',
    opacity: 0.6,
  },
  ripple1: {
    backgroundColor: '#BEABFF',
  },
  ripple2: {
    animationDelay: '-250ms',
    backgroundColor: '#A68CFF',
  },
  ripple3: {
    animationDelay: '-500ms',
    backgroundColor: '#7C69BF',
  },
  ripple4: {
    animationDelay: '-750ms',
    backgroundColor: '#8866FF',
  },
  '@keyframes ripple': {
    to: { transform: 'scale(1)' },
  },
})

function Transition(props) {
  return <Slide direction="down" {...props} />
}

class MarketingDashboard extends Component {
  state = {
    isFetching: false,
    showReportSettings: false,
    showReportDialog: false,
    goals: [],
    leadsGoalId: null,
    ordersGoalId: null,
    summaryData: {},
    tableData: [],
    startDate: '',
    endDate: '',
    showCalendar: false,
    costDataByDays: [],
    revenueDataByDays: [],
    overlayUpdateOpen: false,
    eventPointers: 'none',
    isReportConfigurated: window.state.isReportConfigurated,
  }

  componentDidMount() {
    if (this.props.isDemo) {
      this.getDashboardData()
    }
  }

  handleGetReportSettings = () => {
    this.setState({
      isFetching: true,
    })

    this.handleOpenReportSettings()

    const url = '/report/settings'

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState({
          goals: data.goals,
          leadsGoalId: data.leadsGoalId,
          ordersGoalId: data.ordersGoalId,
        })
      })
      .catch(errors)
  }

  getDashboardData = () => {
    this.setState({
      isFetching: true,
    })

    let url = '/report'

    if (this.props.isDemo) {
      url = '/report/demo'
    }

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState(
          {
            tableData: data.tableData,
            summaryData: data.summaryData,
            startDate: data.fromDate,
            endDate: data.toDate,
            costDataByDays: data.costDataByDays,
            revenueDataByDays: data.revenueDataByDays,
          },
          () => {
            this.handleOpenReportDialog()
          }
        )
      })
      .catch(errors)
  }

  handleOpenReportSettings = () => {
    this.setState({
      showReportSettings: true,
      // showReportDialog: false,
      isFetching: false,
    })
  }

  handleCloseReportSettings = () => {
    this.setState({
      showReportSettings: false,
      isFetching: false,
    })
  }

  handleOpenReportDialog = () => {
    this.setState({
      showReportDialog: true,
      showReportSettings: false,
      isFetching: false,
    })
  }

  handleCloseReportDialog = () => {
    this.setState({
      showReportDialog: false,
      isFetching: false,
    })
  }

  showDashboard = status => {
    if (status === 'ok') {
      this.setState({
        isReportConfigurated: true,
      })
      this.getDashboardData()
    }
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/report/settings'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        this.showDashboard(status)
      })
      .catch(errors)
  }

  handleCalendarShow = () => {
    this.setState(prevState => {
      return {
        showCalendar: !prevState.showCalendar,
      }
    })
  }

  handleGetRange = (startDate, endDate) => {
    this.setState({
      startDate,
      endDate,
    })
  }

  getDashboardDataWithPeriod = (startDate, endDate) => {
    this.setState({
      isFetching: true,
    })

    const formatStartDate = format(startDate, 'YYYY-MM-DD')
    const formatEndDate = format(endDate, 'YYYY-MM-DD')

    const url = `/report/${formatStartDate}/${formatEndDate}`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState(
          {
            tableData: data.tableData,
            summaryData: data.summaryData,
            costDataByDays: data.costDataByDays,
            revenueDataByDays: data.revenueDataByDays,
            isFetching: false,
          },
          () => {
            return this.handleCalendarShow()
          }
        )
      })
      .catch(errors)
  }

  updateDashboard = () => {
    this.setState({
      overlayUpdateOpen: true,
    })

    const formatStartDate = format(this.state.startDate, 'YYYY-MM-DD')
    const formatEndDate = format(this.state.endDate, 'YYYY-MM-DD')

    const url = `/report/${formatStartDate}/${formatEndDate}`

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState(
          {
            tableData: data.tableData,
            summaryData: data.summaryData,
            costDataByDays: data.costDataByDays,
            revenueDataByDays: data.revenueDataByDays,
            isFetching: false,
          },
          () => {
            this.setState({
              overlayUpdateOpen: false,
            })
          }
        )
      })
      .catch(errors)
  }

  render() {
    const {
      summaryData,
      tableData,
      goals,
      leadsGoalId,
      ordersGoalId,
      isFetching,
      startDate,
      endDate,
      showCalendar,
      costDataByDays,
      revenueDataByDays,
      overlayUpdateOpen,
      showReportSettings,
      isReportConfigurated,
    } = this.state
    const { classes, project, isDemo } = this.props

    const fromDate = format(startDate, 'DD MMM YYYY', { locale: ruLocale })
    const toDate = format(endDate, 'DD MMM YYYY', { locale: ruLocale })

    const costChart = (
      <MChart
        label="Расходы на рекламу"
        data={costDataByDays}
        fill={false}
        showGridline
        gridLinesColor={'rgba(0, 0, 0, 0.2)'}
        zeroLineColor={'#979797'}
        fontColor={'#000000'}
        chartColor={'#8866ff'}
        symbol={'₽'}
      />
    )
    const revenueChart = (
      <MChart
        label="Выручка"
        data={revenueDataByDays}
        fill={false}
        showGridline
        gridLinesColor={'rgba(0, 0, 0, 0.2)'}
        zeroLineColor={'#979797'}
        fontColor={'#000000'}
        chartColor={'#8866ff'}
        symbol={'₽'}
      />
    )

    return (
      <div>
        <BannerReportAnalitycsBrick
          isDemo={isDemo}
          isFetching={isFetching}
          getData={this.getDashboardData}
          getSetting={this.handleGetReportSettings}
          isConfig={isReportConfigurated}
        />

        <PopupSettings
          isFetching={isFetching}
          isOpen={showReportSettings}
          close={this.handleCloseReportSettings}
          goals={goals}
          leads={leadsGoalId}
          orders={ordersGoalId}
          submit={this.handleSubmit}
        />

        {/* Dashboard dialog */}
        <Dialog
          fullScreen
          open={this.state.showReportDialog}
          TransitionComponent={Transition}
          PaperProps={{
            classes: {
              root: classes.reportDialog,
            },
          }}
        >
          className=
          {cx(classes.brick, {
            [classes.brickNoData]: summaryData.leads === null,
          })}
          {overlayUpdateOpen && (
            <div className={classes.overlayUpdate}>
              <div className={classes.loading}>
                <div className={cx(classes.ripple, classes.ripple1)}></div>
                <div className={cx(classes.ripple, classes.ripple2)}></div>
                <div className={cx(classes.ripple, classes.ripple3)}></div>
                <div className={cx(classes.ripple, classes.ripple4)}></div>
              </div>
            </div>
          )}
          <AppBar className={classes.reportDialogAppBar} elevation={0}>
            <Toolbar
              style={{
                maxWidth: '100%',
                margin: '0 auto',
                width: '100%',
                height: 80,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 10px',
              }}
            >
              <div className={classes.appBarTitle}>
                <LogoData customClass={classes.logoRow} />
                {project}
              </div>

              {!isDemo ? (
                <div className={classes.appBarActions}>
                  <ButtonContained
                    onClick={this.handleCalendarShow}
                    customClass={classes.toggleCalendar}
                    color="secondary"
                    text={`${fromDate} - ${toDate}`}
                  />

                  <ButtonContained
                    style={{
                      width: 120,
                      fontSize: 16,
                      height: 40,
                      padding: 0,
                      marginRight: 10,
                    }}
                    onClick={this.updateDashboard}
                    color="secondary"
                    text={`Обновить`}
                  />

                  {showCalendar && (
                    <div className={classes.dateRangeWrapper}>
                      <MDateRangePicker
                        startDate={startDate}
                        endDate={endDate}
                        getRange={this.handleGetRange}
                        getDashboardWithPeriod={this.getDashboardDataWithPeriod}
                        toggleRange={this.handleCalendarShow}
                        isFetching={isFetching}
                      />
                    </div>
                  )}

                  <button
                    className={classes.mSettingBtn}
                    onClick={this.handleGetReportSettings}
                  >
                    <Setting width={24} height={24} fill="#8866ff" />
                  </button>

                  <IconButton
                    color="inherit"
                    onClick={this.handleCloseReportDialog}
                    aria-label="Close"
                    style={{ marginLeft: 'auto' }}
                  >
                    <CloseIcon style={{ fill: '#8866ff' }} />
                  </IconButton>
                </div>
              ) : (
                <ButtonContained
                  href="/register?utm_source=demo_dashboard&utm_medium=button&utm_campaign=demo"
                  customClass={classes.toggleCalendar}
                  color="secondary"
                  text="Попробовать бесплатно"
                />
              )}
            </Toolbar>
          </AppBar>
          <div className={classes.reportDialogWrapper}>
            {showCalendar && (
              <div
                className={classes.backDropDateRange}
                onClick={this.handleCalendarShow}
              />
            )}
            <MGrid
              summaryData={summaryData}
              costChart={costChart}
              revenueChart={revenueChart}
            />

            <MTable
              demo={this.props.isDemo}
              summaryData={summaryData}
              data={tableData}
            />
          </div>
        </Dialog>
      </div>
    )
  }
}

export default withStyles(styles)(withSnackbar(MarketingDashboard))
